import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    question: '¿Cuánto tarda la web?',
    answer: 'Normalmente en 48 horas.'
  }, {
    question: '¿Necesito conocimientos técnicos?',
    answer: 'No. Nosotros nos encargamos de todo.'
  }, {
    question: '¿Funciona en móviles?',
    answer: 'Sí, está optimizada para móviles.'
  }, {
    question: '¿Hay mensualidades?',
    answer: 'No, es un pago único.'
  }, {
    question: '¿Para qué negocios funciona?',
    answer: 'Barberías, gimnasios, clínicas, estética, dentistas y negocios locales.'
  }];
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return <section className="py-20 bg-light" data-id="element-35">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="text-center mb-12" data-id="element-37">
          <motion.h2 className="text-3xl font-bold text-text" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-38">
            Preguntas Frecuentes
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, index) => <motion.div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} data-id="element-40">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFaq(index)} aria-expanded={activeIndex === index} data-id="element-41">
                <span className="font-semibold text-text text-lg" data-id="element-42">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`} data-id="element-43" />
              </button>
              <AnimatePresence data-id="element-44">
                {activeIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-45">
                    <div className="px-6 pb-5 text-gray-600" data-id="element-46">{faq.answer}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}